module.exports = " <div class=theme-fieldtype-wrapper> <div v-if=loading class=\"loading loading-basic\"> <span class=\"icon icon-circular-graph animation-spin\"></span> {{ translate('cp.loading') }} </div> <select-fieldtype v-if=!loading :name=name :data.sync=data :config=selectConfig></select-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/ThemeFieldtype.vue
// module id = 770
// module chunks = 0